import { createContext, useContext, useState, useEffect } from "react";
import { toast } from "sonner";

const QuoteContext = createContext(null);
const KEY = "vitalis_devis";

export function QuoteProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; }
  });

  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify(items));
  }, [items]);

  const add = (product) => {
    setItems((prev) => {
      if (prev.find((i) => i.product_id === product.product_id)) return prev;
      return [...prev, {
        product_id: product.product_id, title: product.title, price: product.price,
        cover: product.cover, category: product.category,
        subtype: product.service_type || product.dev_type || "",
        short_description: product.short_description || "",
        description: (product.description || "").replace(/<[^>]*>/g, " ").replace(/\s+/g, " ").trim(),
        delay: product.dev_delay || product.service_duration || "",
        qty: 1, maintenance: false, conditions: "",
      }];
    });
    toast.success("Ajouté au devis");
  };

  const has = (product_id) => items.some((i) => i.product_id === product_id);
  const update = (product_id, patch) =>
    setItems((prev) => prev.map((i) => i.product_id === product_id ? { ...i, ...patch } : i));
  const remove = (product_id) => setItems((prev) => prev.filter((i) => i.product_id !== product_id));
  const clear = () => setItems([]);
  const count = items.length;

  return (
    <QuoteContext.Provider value={{ items, add, has, update, remove, clear, count }}>
      {children}
    </QuoteContext.Provider>
  );
}

export const useQuote = () => useContext(QuoteContext);
